"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ palette, spacing }) => ({
    settingButton: {
        backgroundColor: palette.surface.raised,
        borderColor: palette.border.default,
        '&:hover': {
            background: palette.surface.raised,
        },
    },
    customDateRange: {
        borderRadius: 4,
        padding: '10px 8px',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1,
        marginLeft: 8,
        '&:hover': {
            background: palette.border.main,
        },
    },
    filterButton: {
        '&.ho': {
            background: palette.background.primary,
            borderColor: palette.primary.main,
        },
    },
    filterClearButton: {
        position: 'absolute',
        top: -10,
        right: -10,
        background: palette.text.secondary,
        fontSize: 17,
        fontWeight: 600,
        color: palette.text.contrastText,
        borderRadius: '50%',
        padding: 2,
        '&:hover': {
            background: palette.text.primary,
        },
    },
    filterNumberIcon: {
        color: palette.secondary.contrastText,
        background: palette.primary.main,
        padding: 5,
        lineHeight: 0.8,
        fontSize: '14px !important',
        borderRadius: 4,
        position: 'relative',
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    filtersContainer: {
        paddingTop: 20,
        marginLeft: 24,
    },
    dateRangeContainer: {
        marginLeft: 24,
    },
    groupBySpacer: {
        width: 0,
        height: 55,
        borderRight: `1px solid ${palette.border.dark}`,
        marginTop: 5,
        marginRight: 16,
        marginLeft: 16,
    },
    root: {
        display: 'flex',
        padding: '10px 20px',
        backgroundColor: palette.background.settingsBarBackground,
        alignItems: 'center',
        borderRadius: 0,
        borderBottom: `1px solid ${palette.border.strong}`,
    },
    groupByTabName: {
        textTransform: 'capitalize',
    },
    reportsMenuLabel: {
        marginBottom: -2,
    },
    downloadButtonWrapper: {
        marginLeft: 'auto',
        fonySize: 14,
        display: 'flex',
        alignItems: 'center',
        gap: spacing(2),
    },
    downloadButton: {
        border: `1px solid ${palette.border.default}`,
        backgroundColor: palette.surface.raised,
        padding: 5,
    },
    downloadIcon: {
        marginRight: 5,
    },
});
exports.default = styles;
